import { useEffect, useState } from 'react'

import { createSwitch } from '@/utils'

export const useFormSelect = (
  value: string,
  onChange: (value: string) => void
) => {
  const [selected, setSelected] = useState(value)

  useEffect(() => {
    setSelected(value)
  }, [value])

  const switcher = createSwitch()
    .case(['informational'], () => {
      setSelected('Informational')
      onChange('Informational')
    })
    .case(['commercial'], () => {
      setSelected('Commercial')
      onChange('Commercial')
    })
    .case(['transactional'], () => {
      setSelected('Transactional')
      onChange('Transactional')
    })
    .case(['navigational'], () => {
      setSelected('Navigational')
      onChange('Navigational')
    })

  const handleOnClick = (keys: string[]) => switcher.run(keys)

  return {
    selected,
    handleOnClick,
  }
}
